<template>
	<section>
		<p>Are you sure you want to delete {{ partnerName }} as a partner?</p>
	</section>
</template>

<script>
export default {
	name: 'PartnersDeleteItem',
	props: {
		partnerName: String,
	},
};
</script>

<style></style>
